import * as request from '@/utils/request'

export default {
  //红人意见
  /**
   * 红人意见
   * @param id 选品ID
   * @param state 红人意见（同上播状态）
   * @returns {Promise}
   */
  updateLbVideoSelectionState(data) {
    return request.post('/lb_schedule_video/update_state', data)
  },
  /**
   * 指定字段修改选品信息
   * @param id
   * @param field
   * @param val
   * @returns {Promise}
   */
  singleSaveVideoScheduleProduct(id, field, val) {
    let data = { id: id, field: field, val: val }
    return request.post('/lb_schedule_video/single_save_product', data)
  },

  /**
   * 获取排期详情
   * @param {*} id
   * @returns {Promise}
   */
  getVideoScheduleInfo(id) {
    let data = { id: id }
    return request.post('/lb_schedule_video/get_info', data)
  },

  /**
   * 获取已确认的选品
   * @returns {Promise}
   */
  getVideoScheduleAckProducts(data) {
    return request.post('/lb_schedule_video/get_products', data)
  },
  /**
   * 删除直播选品
   * @param id
   * @returns {*}
   */
  delVideoScheduleProducts(id) {
    return request.post('/lb_schedule_video/del_lb_products', { id: id })
  },
  /**
   * 初选商品
   * @param id
   * @returns {Promise}
   */
  originalVideoSchedule(id) {
    let data = { id: id }
    return request.post('/lb_schedule_video/original', data)
  },

  /**
   * 标记初选选品为“确认选品”
   * @returns {Promise}
   * @param ids
   */
  tagVideoScheduleProducts(data) {
    return request.post('/lb_schedule_video/tag', data)
  },
  cancelVideoTagLbScheduleProducts(data) {

    return request.post('/lb_schedule_video/cancel_tag', data)
  },
  /**
   * 保存-确认选品排序
   */
  saveVideoScheduleOrder(data) {
    return request.post('/lb_schedule_video/order', data)
  },
  /**
   * 未选上及其原因
   * @param ids
   * @param cancel_reason
   * @returns {Promise}
   */
  cancelVideoSelectionScheduleProducts(data) {
    // let data = { ids: ids, cancel_reason: cancel_reason }
    return request.post('/lb_schedule_video/cancel_selection', data)
  },
  /**
   * 机制确认
   * @param ids
   * @param cancel_reason
   * @returns {Promise}
   */
  changeVideoConfirmScheduleProducts(ids, confirm_status) {
    let data = { ids: ids, confirm_status: confirm_status }
    return request.post('/lb_schedule_video/change_confirm', data)
  },

  /**
   * 确认选品
   * @param id
   * @returns {Promise}
   */
  ackVideoSchedule(id) {
    let data = { id: id }
    return request.post('/lb_schedule_video/ack', data)
  },
  /**
   * 锁定表格
   * @param id
   * @returns {Promise}
   */
  lockVideoSchedule(id) {
    let data = { id: id }
    return request.post('/lb_schedule_video/lock', data)
  },
  /**
   * 红人选品会-查询
   * @param data
   * @returns {Promise}
   */
  getVideoScheduleKolSelection(data) {
    return request.post('/lb_schedule_video/get_kol_selection', data)
  },
  /**
   * 查询待选品（排查已选）
   * @param data
   * @returns {Promise}
   */
  getVideoProductListExclude(data) {
    return request.post('/lb_schedule_video/get_products_await', data)
  },
  /**
   * 追加直播选品
   * @param data
   * @returns {Promise}
   */
  appendVideoScheduleProducts(data) {
    return request.post('/lb_schedule_video/append_products', data)
  },

  //单元格数据保存
  cellSaveVideoScheduleDemandItemInfo(data) {
    return request.post('/lb_schedule_video/single_save_demand', data)
  },
  //需求明细CURD
  saveVideoScheduleDemandItem(data) {
    return request.post('/lb_schedule_video/save_demand_item', data)
  },

  /**
   * 导出红人选品会明细
   * @param data
   * @returns {Promise}
   */
  exportVideoScheduleDemandItem(data) {
    return request.postBlob('/lb_schedule_video/export_demand_item', data)
  },
  /**
   *
   * @param id
   * @returns {Promise}
   */
  delVideoScheduleDemandItem(id) {
    let data = { id: id }
    return request.post('/lb_schedule_video/del_demand_item', data)
  },
  getVideoScheduleDemandItemList(data) {
    return request.post('/lb_schedule_video/list_demand_item', data)
  },
  /**
   *批量删除
   * @param ids
   * @param lb_id
   * @returns {Promise}
   */
  delBatchVideoScheduleDemandItem(ids, lb_id) {
    let data = { ids: ids,lb_id: lb_id }
    return request.post('/lb_schedule_video/del_batch_demand_item', data)
  },
  /**
   * 保存选品
   * @param data
   * @returns {Promise}
   */
  saveVideoScheduleProducts(data) {

    return request.post('/lb_schedule_video/save_products', data)
  },
  /**
   * 获取指定选品的信息
   * @param id
   * @returns {Promise}
   */
  getVideoScheduleProductInfo(id) {
    let data = { id: id }
    return request.post('/lb_schedule_video/get_lb_product_info', data)
  },
  /**
   * 修改产品机制（招商）
   * @param data
   * @returns {Promise}
   */
  saveVideoScheduleProductInfo(data) {
    return request.post('/lb_schedule_video/save_product', data)
  },
  /**
   * 日志查看接口
   * @param data
   * @returns {Promise}
   */
  getLbVideoSelectionLog(data) {
    return request.post('/lb_schedule_video/log', data)
  },
}
